import React, { Component } from 'react'
import { Link } from "react-router-dom"
import moment from "moment"
function cuttext(text, maxlength) {
  if (text.length > maxlength) {
    var newtext = text.slice(0, maxlength);
    newtext += "..."
    return newtext
  } else return text
}
const ListCourse = ({ course }) => (
  <div className="single-course clearfix x-listview">
    <div className="image-box float-left"><img src={course.image} alt={course.title} /></div>
    <div className="text float-left">
      
      <h5>
        <Link to={`/courses/${course.slug}`} className="tran3s">{course.title}</Link>
      </h5>
      <p>{cuttext(course.description, 80)}</p>
      <div className="name clearfix">
      
        {course.isNewCourse ? <span class="p-bg-color float-right">New</span> : null}
      </div> <ul className="clearfix">
        <li className="float-left">
          <i className="flaticon-time"></i>
          <a href="#" className="tran3s">{moment.utc(course.duration * 1000).format('m')} min</a>
        </li>
        {/* <li className="float-left">
            <i className="flaticon-heart"></i>
              <a href="#" className="tran3s">{course.likes}</a>
            </li> */}
        {/* <li className="float-right">
            {course.isNewCourse?<span className="p-bg-color" style={{padding:'0 1em'}}>New</span>:null}
             
            </li> */}
      </ul>
    </div>
  </div>
)
export default ListCourse
